import { render, staticRenderFns } from "./ModelViewVulkan.vue?vue&type=template&id=4342dec5&scoped=true"
import script from "./ModelViewVulkan.vue?vue&type=script&lang=js"
export * from "./ModelViewVulkan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4342dec5",
  null
  
)

export default component.exports